// ==============================|| THEME CONSTANT  ||============================== //
// import axios from "axios";
// export const url = 'http://localhost:3001/api/v1'

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/';
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 260;

export const SSO_PATHS = {
  DEV: 'https://auth-qa.zignaai.com',
  QA: 'https://auth-qa.zignaai.com',
  PROD: 'https://auth.zignaai.com',
  DEMO: 'https://auth-qa.zignaai.com',
  UAT: 'https://auth-qa.zignaai.com'
};

// S3 Configuration
export const S3_CONFIG = {
  BUCKET: 'zai-prod-policies',
  REGION: 'us-east-1'
};

// Utility function to construct full S3 URL from key
export const constructS3Url = (key) => {
  return `https://${S3_CONFIG.BUCKET}.s3.amazonaws.com/${key}`;
};

export const ThemeMode = {
  LIGHT: 'light',
  DARK: 'dark'
};

export const MenuOrientation = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};

export const ThemeDirection = {
  LTR: 'ltr',
  RTL: 'rtl'
};

export const TAG_COLORS = {
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
  SECONDARY: 'secondary'
};

export const WORK_FLOW_STATE_KEY = {
  READY_TO_WORK: 'ready_to_work',
  IN_PROGRESS: 'in_progress',
  AUDIT_STARTED: 'audit_started',
  ON_HOLD: 'on_hold',
  COMPLETE: 'audit_complete'
};

export const AUDIT_STATUS_TAG = {
  [WORK_FLOW_STATE_KEY.READY_TO_WORK]: TAG_COLORS.WARNING,
  [WORK_FLOW_STATE_KEY.ON_HOLD]: TAG_COLORS.ERROR,
  [WORK_FLOW_STATE_KEY.IN_PROGRESS]: TAG_COLORS.SECONDARY,
  [WORK_FLOW_STATE_KEY.AUDIT_STARTED]: TAG_COLORS.SECONDARY,
  [WORK_FLOW_STATE_KEY.COMPLETE]: TAG_COLORS.SUCCESS
};

const DIAGNOSIS_CODES_STATUS_TYPES = {
  Y: 'Y',
  N: 'N'
};

export const DIAGNOSIS_CODES_STATUS_TAG = {
  [DIAGNOSIS_CODES_STATUS_TYPES.N]: TAG_COLORS.ERROR,
  [DIAGNOSIS_CODES_STATUS_TYPES.Y]: TAG_COLORS.SUCCESS
};

const ONBOARD_PAYERS_DATALENGTH = {
  SAMPLE: 'Sample Data',
  FULL: 'Full Data'
};

export const ONBOARD_PAYERS_DATALENGTH_TAG = {
  [ONBOARD_PAYERS_DATALENGTH.SAMPLE]: TAG_COLORS.WARNING,
  [ONBOARD_PAYERS_DATALENGTH.FULL]: TAG_COLORS.SUCCESS
};

// ======= REDUX ACTIONS ========= //

export const AUTH_ACTIONS = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  REGISTER: 'REGISTER',
  UPDATE_STATUS: 'UPDATE_STATUS',
  UPDATE_PERMISSION: 'UPDATE_PERMISSION',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_PERMISSION: 'SET_PERMISSION',
  SET_ORGS: 'SET_ORGS',
  UPDATE_AUTH: 'SET_AUTH',
  UPDATE_DATABASE: 'UPDATE_DATABASE'
};

export const MENU_ACTIONS = {
  ACTIVE_ITEM: 'ACTIVE_ITEM',
  ACTIVE_ID: 'ACTIVE_ID',
  ACTIVE_COMPONENT: 'ACTIVE_COMPONENT',
  OPEN_DRAWER: 'OPEN_DRAWER',
  OPEN_COMPONENT_DRAWER: 'OPEN_COMPONENT_DRAWER',
  HAS_ERROR: 'HAS_ERROR'
};

export const SNACKBAR_ACTIONS = {
  OPEN_SNACKBAR: 'OPEN_SNACKBAR',
  CLOSE_SNACKBAR: 'CLOSE_SNACKBAR',
  HANDLER_INCREASE: 'HANDLER_INCREASE',
  HANDLER_DENSE: 'HANDLER_DENSE',
  HANDLER_ICON_VARIANTS: 'HANDLER_ICON_VARIANTS'
};

export const REPORTS_ACTIONS = {
  REQUEST_BATCH_WISE_CLAIM_COUNT_DATA: 'REQUEST_BATCH_WISE_CLAIM_COUNT_DATA'
};

export const SIDEBAR_ACTIONS = {
  CHANGE_SIDEBAR: 'CHANGE_SIDEBAR',
  SET_USER_TYPE: 'SET_USER_TYPE'
};

export const POLICY_CATALOGUE_ACTIONS = {
  GET_ALL_POLICIES: 'GET_ALL_POLICIES',
  SAVE_ALL_POLICIES: 'SAVE_ALL_POLICIES',
  SET_ALL_POLICIES_ERROR: 'SET_ALL_POLICIES_ERROR'
};

export const DATA_AUDIT_ACTIONS = {
  REQUEST_DISTING_DRG_BY_NEGOTIATIONS: 'REQUEST_DISTING_DRG_BY_NEGOTIATIONS',
  REQUEST_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE: 'REQUEST_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE',
  REQUEST_DRG_REFERENCE_TABLE: 'REQUEST_DRG_REFERENCE_TABLE',
  REQUEST_HOSPITAL_COUNT_BY_DRG: 'REQUEST_HOSPITAL_COUNT_BY_DRG',
  REQUEST_HOSPITAL_COUNT_DRG: 'REQUEST_HOSPITAL_COUNT_DRG',
  REQUEST_NPI_DISTRIBUTION_ACROSS_COUNTRY: 'REQUEST_NPI_DISTRIBUTION_ACROSS_COUNTRY',
  REQUEST_PCH_BILLING_CODE_MODIFIER: 'REQUEST_PCH_BILLING_CODE_MODIFIER',
  REQUEST_PCH_CITY: 'REQUEST_PCH_CITY',
  REQUEST_PCH_CODE_TYPE: 'REQUEST_PCH_CODE_TYPE',
  REQUEST_PCH_L1_DESCRIPTION: 'REQUEST_PCH_L1_DESCRIPTION',
  REQUEST_PCH_NEGOTIATED_TYPE: 'REQUEST_PCH_NEGOTIATED_TYPE',
  REQUEST_PCH_REPORTING_ENTITY: 'REQUEST_PCH_REPORTING_ENTITY',
  REQUEST_PROCEDURE_COST_BY_HOSPITAL: 'REQUEST_PROCEDURE_COST_BY_HOSPITAL',
  REQUEST_PROVIDER_DRG_BY_HOSPITAL: 'REQUEST_PROVIDER_DRG_BY_HOSPITAL',
  REQUEST_STATE_DRG_BY_HOSPITAL: 'REQUEST_STATE_DRG_BY_HOSPITAL',
  REQUEST_STATIC_BCBV_DATA: 'REQUEST_STATIC_BCBV_DATA',
  REQUEST_STATIC_CHART_DATA: 'REQUEST_STATIC_CHART_DATA',
  RESET_HOSPITAL_COUNT_WITH_N_TYPE: 'RESET_HOSPITAL_COUNT_WITH_N_TYPE',
  RESET_PCH_FILTERS_STATE: 'RESET_PCH_FILTERS_STATE',
  RESET_PCH_LIST: 'RESET_PCH_LIST',
  SET_DATA_AUDIT_TYPE: 'SET_DATA_AUDIT_TYPE',
  SET_DISTING_DRG_BY_NEGOTIATIONS_ERROR: 'SET_DISTING_DRG_BY_NEGOTIATIONS_ERROR',
  SET_DISTING_DRG_BY_NEGOTIATIONS: 'SET_DISTING_DRG_BY_NEGOTIATIONS',
  SET_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE_ERROR: 'SET_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE_ERROR',
  SET_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE: 'SET_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE',
  SET_DRG_REFERENCE_TABLE_ERROR: 'SET_DRG_REFERENCE_TABLE_ERROR',
  SET_DRG_REFERENCE_TABLE: 'SET_DRG_REFERENCE_TABLE',
  SET_HOSPITAL_COUNT_DRG_ERROR: 'SET_HOSPITAL_COUNT_DRG_ERROR',
  SET_HOSPITAL_COUNT_DRG: 'SET_HOSPITAL_COUNT_DRG',
  SET_NPI_DISTRIBUTION_ACROSS_COUNTRY_ERROR: 'SET_NPI_DISTRIBUTION_ACROSS_COUNTRY_ERROR',
  SET_NPI_DISTRIBUTION_ACROSS_COUNTRY: 'SET_NPI_DISTRIBUTION_ACROSS_COUNTRY',
  SET_PCH_CITY_ERROR: 'SET_PCH_CITY_ERROR',
  SET_PCH_CITY: 'SET_PCH_CITY',
  SET_PCH_REPORTING_ENTITY_ERROR: 'SET_PCH_REPORTING_ENTITY_ERROR',
  SET_PCH_REPORTING_ENTITY: 'SET_PCH_REPORTING_ENTITY',
  SET_PROCEDURE_COST_BY_HOSPITAL_ERROR: 'SET_PROCEDURE_COST_BY_HOSPITAL_ERROR',
  SET_PROCEDURE_COST_BY_HOSPITAL: 'SET_PROCEDURE_COST_BY_HOSPITAL',
  SET_PROVIDER_DRG_BY_HOSPITAL_ERROR: 'SET_PROVIDER_DRG_BY_HOSPITAL_ERROR',
  SET_PROVIDER_DRG_BY_HOSPITAL: 'SET_PROVIDER_DRG_BY_HOSPITAL',
  SET_REQUEST_PCH_BILLING_CODE_MODIFIER_ERROR: 'SET_REQUEST_PCH_BILLING_CODE_MODIFIER_ERROR',
  SET_REQUEST_PCH_BILLING_CODE_MODIFIER: 'SET_REQUEST_PCH_BILLING_CODE_MODIFIER',
  SET_REQUEST_PCH_CODE_TYPE_ERROR: 'SET_REQUEST_PCH_CODE_TYPE_ERROR',
  SET_REQUEST_PCH_CODE_TYPE: 'SET_REQUEST_PCH_CODE_TYPE',
  SET_REQUEST_PCH_L1_DESCRIPTION_ERROR: 'SET_REQUEST_PCH_L1_DESCRIPTION_ERROR',
  SET_REQUEST_PCH_L1_DESCRIPTION: 'SET_REQUEST_PCH_L1_DESCRIPTION',
  SET_REQUEST_PCH_NEGOTIATED_TYPE_ERROR: 'SET_REQUEST_PCH_NEGOTIATED_TYPE_ERROR',
  SET_REQUEST_PCH_NEGOTIATED_TYPE: 'SET_REQUEST_PCH_NEGOTIATED_TYPE',
  SET_STATE_DRG_BY_HOSPITAL_ERROR: 'SET_STATE_DRG_BY_HOSPITAL_ERROR',
  SET_STATE_DRG_BY_HOSPITAL: 'SET_STATE_DRG_BY_HOSPITAL',
  SET_STATIC_BCBV_DATA_ERROR: 'SET_STATIC_BCBV_DATA_ERROR',
  SET_STATIC_BCBV_DATA: 'SET_STATIC_BCBV_DATA',
  SET_STATIC_CHART_DATA_ERROR: 'SET_STATIC_CHART_DATA_ERROR',
  SET_STATIC_CHART_DATA: 'SET_STATIC_CHART_DATA'
};

export const FACILITY_AND_ANCILLARY_ACTIONS = {
  REQUEST_ANCILLARY_LIST: 'REQUEST_ANCILLARY_LIST',
  REQUEST_BILLING_CODE_TYPE_LIST: 'REQUEST_BILLING_CODE_TYPE_LIST',
  REQUEST_CATEGORY_LIST: 'REQUEST_CATEGORY_LIST',
  REQUEST_DRG_BREAKDOWN: 'REQUEST_DRG_BREAKDOWN',
  REQUEST_DRG_CODE_CATEGORY: 'REQUEST_DRG_CODE_CATEGORY',
  REQUEST_DRG_COST_ALLENTITY: 'REQUEST_DRG_COST_ALLENTITY',
  REQUEST_DRG_PROVIDER_NAME: 'REQUEST_DRG_PROVIDER_NAME',
  REQUEST_DRG_REPORTING_ENTITY_NAME: 'REQUEST_DRG_REPORTING_ENTITY_NAME',
  REQUEST_DRGBILLING_CODE_TYPE: 'REQUEST_DRGBILLING_CODE_TYPE',
  REQUEST_DRGBILLING_CODES: 'REQUEST_DRGBILLING_CODES',
  REQUEST_DRGHOSPITAL_LIST: 'REQUEST_DRGHOSPITAL_LIST',
  REQUEST_DRGLIST_DATA: 'REQUEST_DRGLIST_DATA',
  REQUEST_DRGPAYER_LIST: 'REQUEST_DRGPAYER_LIST',
  REQUEST_HOSPITAL_LIST: 'REQUEST_HOSPITAL_LIST',
  REQUEST_L1_DESCRIPTION: 'REQUEST_L1_DESCRIPTION',
  REQUEST_MODIFIER_LIST: 'REQUEST_MODIFIER_LIST',
  REQUEST_NPI_LIST: 'REQUEST_NPI_LIST',
  REQUEST_OVERVIEW_CPT_LIST: 'REQUEST_OVERVIEW_CPT_LIST',
  REQUEST_OVERVIEW_DRG_LIST: 'REQUEST_OVERVIEW_DRG_LIST',
  REQUEST_PAYER_LIST: 'REQUEST_PAYER_LIST',
  REQUEST_PAYER_PRICE_DIFF_LIST: 'REQUEST_PAYER_PRICE_DIFF_LIST',
  REQUEST_PAYER_PROC_COUNT: 'REQUEST_PAYER_PROC_COUNT',
  REQUEST_PROCEDURE_CATEGORY: 'REQUEST_PROCEDURE_CATEGORY',
  REQUEST_PROCEDURE_NAME_LIST: 'REQUEST_PROCEDURE_NAME_LIST',
  REQUEST_REGIONAL_MAP_DATA_LIST: 'REQUEST_REGIONAL_MAP_DATA_LIST',
  REQUEST_STATE_MAP_DATA_LIST: 'REQUEST_STATE_MAP_DATA_LIST',
  REQUEST_TOP_PREF_ENTITY_LIST: 'REQUEST_TOP_PREF_ENTITY_LIST',
  REQUEST_TOP_PROCEDURE_L4: 'REQUEST_TOP_PROCEDURE_L4',
  REQUEST_TOP_PROCEDURE_NON_PREF_L4: 'REQUEST_TOP_PROCEDURE_NON_PREF_L4',
  RESET_FILTER_STATE: 'RESET_FILTER_STATE',
  RESET_FILTERED_DRG_LIST_FILTER_STATE: 'RESET_FILTERED_DRG_LIST_FILTER_STATE',
  RESET_DRG_COST_FILTER_STATE: 'RESET_DRG_COST_FILTER_STATE',
  RESET_PAYER_PRICE_COMP_LIST: 'RESET_PAYER_PRICE_COMP_LIST',
  SET_ANCILLARY_LIST_ERROR: 'SET_ANCILLARY_LIST_ERROR',
  SET_ANCILLARY_LIST: 'SET_ANCILLARY_LIST',
  SET_BILLING_CODE_TYPE_LIST_ERROR: 'SET_BILLING_CODE_TYPE_LIST_ERROR',
  SET_BILLING_CODE_TYPE_LIST: 'SET_BILLING_CODE_TYPE_LIST',
  SET_CATEGORY_LIST_ERROR: 'SET_CATEGORY_LIST_ERROR',
  SET_CATEGORY_LIST: 'SET_CATEGORY_LIST',
  SET_DRG_BREAKDOWN_ERROR: 'SET_DRG_BREAKDOWN_ERROR',
  SET_DRG_BREAKDOWN: 'SET_DRG_BREAKDOWN',
  SET_DRG_CODE_CATEGORY_ERROR: 'SET_DRG_CODE_CATEGORY_ERROR',
  SET_DRG_CODE_CATEGORY: 'SET_DRG_CODE_CATEGORY',
  SET_DRG_COST_ALLENTITY_ERROR: 'SET_DRG_COST_ALLENTITY_ERROR',
  SET_DRG_COST_ALLENTITY: 'SET_DRG_COST_ALLENTITY',
  SET_DRG_PROVIDER_NAME_ERROR: 'SET_DRG_PROVIDER_NAME_ERROR',
  SET_DRG_PROVIDER_NAME: 'SET_DRG_PROVIDER_NAME',
  SET_DRG_REPORTING_ENTITY_NAME_ERROR: 'SET_DRG_REPORTING_ENTITY_NAME_ERROR',
  SET_DRG_REPORTING_ENTITY_NAME: 'SET_DRG_REPORTING_ENTITY_NAME',
  SET_DRGBILLING_CODE_TYPE_ERROR: 'SET_DRGBILLING_CODE_TYPE_ERROR',
  SET_DRGBILLING_CODE_TYPE: 'SET_DRGBILLING_CODE_TYPE',
  SET_DRGBILLING_CODES_ERROR: 'SET_DRGBILLING_CODES_ERROR',
  SET_DRGBILLING_CODES: 'SET_DRGBILLING_CODES',
  SET_DRGHOSPITAL_LIST_ERROR: 'SET_DRGHOSPITAL_LIST_ERROR',
  SET_DRGHOSPITAL_LIST: 'SET_DRGHOSPITAL_LIST',
  SET_DRGLIST_DATA_ERROR: 'SET_DRGLIST_DATA_ERROR',
  SET_DRGLIST_DATA: 'SET_DRGLIST_DATA',
  SET_DRGPAYER_LIST_ERROR: 'SET_DRGPAYER_LIST_ERROR',
  SET_DRGPAYER_LIST: 'SET_DRGPAYER_LIST',
  SET_HOSPITAL_LIST_ERROR: 'SET_HOSPITAL_LIST_ERROR',
  SET_HOSPITAL_LIST: 'SET_HOSPITAL_LIST',
  SET_L1_DESCRIPTION_ERROR: 'SET_L1_DESCRIPTION_ERROR',
  SET_L1_DESCRIPTION: 'SET_L1_DESCRIPTION',
  SET_MODIFIER_LIST_ERROR: 'SET_MODIFIER_LIST_ERROR',
  SET_MODIFIER_LIST: 'SET_MODIFIER_LIST',
  SET_NPI_LIST_ERROR: 'SET_NPI_LIST_ERROR',
  SET_NPI_LIST: 'SET_NPI_LIST',
  SET_OVERVIEW_CPT_LIST_ERROR: 'SET_OVERVIEW_CPT_LIST_ERROR',
  SET_OVERVIEW_CPT_LIST: 'SET_OVERVIEW_CPT_LIST',
  SET_OVERVIEW_DRG_LIST_ERROR: 'SET_OVERVIEW_DRG_LIST_ERROR',
  SET_OVERVIEW_DRG_LIST: 'SET_OVERVIEW_DRG_LIST',
  SET_PAYER_LIST_ERROR: 'SET_PAYER_LIST_ERROR',
  SET_PAYER_LIST: 'SET_PAYER_LIST',
  SET_PAYER_PRICE_DIFF_LIST_ERROR: 'SET_PAYER_PRICE_DIFF_LIST_ERROR',
  SET_PAYER_PRICE_DIFF_LIST: 'SET_PAYER_PRICE_DIFF_LIST',
  SET_PAYER_PROC_COUNT_ERROR: 'SET_PAYER_PROC_COUNT_ERROR',
  SET_PAYER_PROC_COUNT: 'SET_PAYER_PROC_COUNT',
  SET_PROCEDURE_CATEGORY_ERROR: 'SET_PROCEDURE_CATEGORY_ERROR',
  SET_PROCEDURE_CATEGORY: 'SET_PROCEDURE_CATEGORY',
  SET_PROCEDURE_NAME_LIST_ERROR: 'SET_PROCEDURE_NAME_LIST_ERROR',
  SET_PROCEDURE_NAME_LIST: 'SET_PROCEDURE_NAME_LIST',
  SET_REGIONAL_MAP_DATA_LIST_ERROR: 'SET_REGIONAL_MAP_DATA_LIST_ERROR',
  SET_REGIONAL_MAP_DATA_LIST: 'SET_REGIONAL_MAP_DATA_LIST',
  SET_SELECTED_STATE: 'SET_SELECTED_STATE',
  SET_STATE_MAP_DATA_LIST_ERROR: 'SET_STATE_MAP_DATA_LIST_ERROR',
  SET_STATE_MAP_DATA_LIST: 'SET_STATE_MAP_DATA_LIST',
  SET_TOP_PREF_ENTITY_LIST_ERROR: 'SET_TOP_PREF_ENTITY_LIST_ERROR',
  SET_TOP_PREF_ENTITY_LIST: 'SET_TOP_PREF_ENTITY_LIST',
  SET_TOP_PROCEDURE_L4_ERROR: 'SET_TOP_PROCEDURE_L4_ERROR',
  SET_TOP_PROCEDURE_L4: 'SET_TOP_PROCEDURE_L4',
  SET_TOP_PROCEDURE_NON_PREF_L4_ERROR: 'SET_TOP_PROCEDURE_NON_PREF_L4_ERROR',
  SET_TOP_PROCEDURE_NON_PREF_L4: 'SET_TOP_PROCEDURE_NON_PREF_L4',
  REQUEST_HISTORICAL_REQUESTS: 'REQUEST_HISTORICAL_REQUESTS',
  SET_HISTORICAL_REQUESTS: 'SET_HISTORICAL_REQUESTS',
  SET_HISTORICAL_REQUESTS_ERROR: 'SET_HISTORICAL_REQUESTS_ERROR',
  REQUEST_PLACE_RE_REQUEST: 'REQUEST_PLACE_RE_REQUEST',
  SET_PLACE_RE_REQUEST: 'SET_PLACE_RE_REQUEST',
  SET_PLACE_RE_REQUEST_ERROR: 'SET_PLACE_RE_REQUEST_ERROR',
  REQUEST_FACILITY_SCORECARD_SCORES: 'REQUEST_FACILITY_SCORECARD_SCORES',
  SET_FACILITY_SCORECARD_SCORES: 'SET_FACILITY_SCORECARD_SCORES',
  SET_FACILITY_SCORECARD_SCORES_ERROR: 'SET_FACILITY_SCORECARD_SCORES_ERROR',
  REQUEST_FACILITY_SCORECARD_NPIS: 'REQUEST_FACILITY_SCORECARD_NPIS',
  SET_FACILITY_SCORECARD_NPIS: 'SET_FACILITY_SCORECARD_NPIS',
  SET_FACILITY_SCORECARD_NPIS_ERROR: 'SET_FACILITY_SCORECARD_NPIS_ERROR',
  REQUEST_PROVIDERS_EXTRACT_FILTERS: 'REQUEST_PROVIDERS_EXTRACT_FILTERS',
  SET_PROVIDERS_EXTRACT_FILTERS: 'SET_PROVIDERS_EXTRACT_FILTERS',
  SET_PROVIDERS_EXTRACT_FILTERS_ERROR: 'SET_PROVIDERS_EXTRACT_FILTERS_ERROR',
  RESET_PROVIDERS_EXTRACT_RESULT: 'RESET_PROVIDERS_EXTRACT_RESULT',
  RESET_PROVIDERS_EXTRACT_CHART_RESULT: 'RESET_PROVIDERS_EXTRACT_CHART_RESULT',
  REQUEST_PROVIDERS_EXTRACT_RESULT: 'REQUEST_PROVIDERS_EXTRACT_RESULT',
  SET_PROVIDERS_EXTRACT_RESULT: 'SET_PROVIDERS_EXTRACT_RESULT',
  SET_PROVIDERS_EXTRACT_RESULT_ERROR: 'SET_PROVIDERS_EXTRACT_RESULT_ERROR',
  REQUEST_PROVIDERS_EXTRACT_RESULT_CHARTS: 'REQUEST_PROVIDERS_EXTRACT_RESULT_CHARTS',
  SET_PROVIDERS_EXTRACT_RESULT_CHARTS: 'SET_PROVIDERS_EXTRACT_RESULT_CHARTS',
  SET_PROVIDERS_EXTRACT_RESULT_CHARTS_ERROR: 'SET_PROVIDERS_EXTRACT_RESULT_CHARTS_ERROR',
  RESET_FILTERED_DRG_LIST: 'RESET_FILTERED_DRG_LIST',
  REQUEST_DRG_ANCILLARY_LIST: 'REQUEST_DRG_ANCILLARY_LIST',
  SET_DRG_ANCILLARY_LIST: 'SET_DRG_ANCILLARY_LIST',
  SET_DRG_ANCILLARY_LIST_ERROR: 'SET_DRG_ANCILLARY_LIST_ERROR'
};

export const MODULES = {
  PROFESSIONAL: 'professional',
  ANCILLARY: 'ancillary',
  FACILITY: 'facility',
  DATA_AUDIT_REPORT: 'dataAuditReport'
};

export const PERMISSION_LIST = {
  PAYER_SCORECARD: 'payer_scorecard',
  REPORT_SUMMARY: 'report_summary',
  PROCEDURE_COST_BY_HOSPITAL: 'procedure_cost_by_hospital',
  DRG_COUNTS_BY_PAYER_AND_HOSPITAL: 'drg_counts_by_payer_and_hospital',
  COMPETITIVE_LANDSCAPE: 'competitive_landscape',
  TOP_CPTS_OVERVIEW: 'top_cpts_overview',
  PROFESSIONAL_RATE_VIEW: 'professional_rate_view',
  PROFESSIONAL_RATE_UTILIZATION_VIEW: 'professional_rate_utilization_view',
  PROFESSIONAL_RATE_VIEW_BY_TIN: 'professional_rate_view_by_tin',
  PROFESSIONAL_RATE_UTILIZATION_VIEW_BY_TIN: 'professional_rate_utilization_view_by_tin',
  PROVIDER_TAX_ID_INSIGHTS: 'provider_tax_id_insights',
  HISTORICAL_REQUESTS: 'historical_requests',
  TOP_DRGS_OVERVIEW: 'top_drgs_overview',
  PAYER_PRICE_COMPARISON_CPT_HCPCS: 'payer_price_comparison_cpt_hcpcs',
  PAYER_PRICE_COMPARISON_DRG: 'payer_price_comparison_drg',
  PAYER_PRICE_COMPARISON_APC: 'payer_price_comparison_apc',
  FILTERED_DRG_LIST: 'filtered_Drg_list',
  DRG_COST_BREAKDOWN: 'drg_cost_breakdown',
  PROVIDERS_CPT_EXTRACT: 'providers_cpt_extract',
  FACILITY_SCORECARD: 'facility_scorecard',
  PROVIDER_CPT_HCPCS_DATA: 'provider_cpt_hcpcs_data'
};

export const PERMISSION_SCHEMA = {
  [MODULES.PROFESSIONAL]: {
    [PERMISSION_LIST.COMPETITIVE_LANDSCAPE]: false,
    [PERMISSION_LIST.TOP_CPTS_OVERVIEW]: false,
    [PERMISSION_LIST.PROFESSIONAL_RATE_VIEW]: false,
    [PERMISSION_LIST.PROFESSIONAL_RATE_UTILIZATION_VIEW]: false,
    [PERMISSION_LIST.PROFESSIONAL_RATE_VIEW_BY_TIN]: false,
    [PERMISSION_LIST.PROFESSIONAL_RATE_UTILIZATION_VIEW_BY_TIN]: false,
    [PERMISSION_LIST.PROVIDER_TAX_ID_INSIGHTS]: false,
    [PERMISSION_LIST.HISTORICAL_REQUESTS]: false
  },
  [MODULES.ANCILLARY]: {
    [PERMISSION_LIST.COMPETITIVE_LANDSCAPE]: false,
    [PERMISSION_LIST.TOP_DRGS_OVERVIEW]: false,
    [PERMISSION_LIST.TOP_CPTS_OVERVIEW]: false,
    [PERMISSION_LIST.PAYER_PRICE_COMPARISON_CPT_HCPCS]: false,
    [PERMISSION_LIST.PAYER_PRICE_COMPARISON_DRG]: false,
    [PERMISSION_LIST.PAYER_PRICE_COMPARISON_APC]: false,
    [PERMISSION_LIST.FILTERED_DRG_LIST]: false,
    [PERMISSION_LIST.DRG_COST_BREAKDOWN]: false,
    [PERMISSION_LIST.PROVIDER_CPT_HCPCS_DATA]: false,
    [PERMISSION_LIST.HISTORICAL_REQUESTS]: false
  },
  [MODULES.FACILITY]: {
    [PERMISSION_LIST.COMPETITIVE_LANDSCAPE]: false,
    [PERMISSION_LIST.TOP_DRGS_OVERVIEW]: false,
    [PERMISSION_LIST.TOP_CPTS_OVERVIEW]: false,
    [PERMISSION_LIST.PAYER_PRICE_COMPARISON_CPT_HCPCS]: false,
    [PERMISSION_LIST.PAYER_PRICE_COMPARISON_DRG]: false,
    [PERMISSION_LIST.PAYER_PRICE_COMPARISON_APC]: false,
    [PERMISSION_LIST.FILTERED_DRG_LIST]: false,
    [PERMISSION_LIST.DRG_COST_BREAKDOWN]: false,
    [PERMISSION_LIST.PROVIDERS_CPT_EXTRACT]: false,
    [PERMISSION_LIST.FACILITY_SCORECARD]: false,
    [PERMISSION_LIST.PROVIDER_CPT_HCPCS_DATA]: false,
    [PERMISSION_LIST.HISTORICAL_REQUESTS]: false
  },
  [MODULES.DATA_AUDIT_REPORT]: {
    [PERMISSION_LIST.PAYER_SCORECARD]: false,
    [PERMISSION_LIST.REPORT_SUMMARY]: false,
    [PERMISSION_LIST.PROCEDURE_COST_BY_HOSPITAL]: false,
    [PERMISSION_LIST.DRG_COUNTS_BY_PAYER_AND_HOSPITAL]: false
  }
};

export const userTypes = ['Professional', 'Facility', 'Ancillary', 'Data Audit Report'];
export const aggregationMeasureList = [
  {
    id: 1,
    name: 'Minimum',
    value: 'Minimum'
  },
  {
    id: 2,
    name: 'Median',
    value: 'Median'
  },
  {
    id: 3,
    name: 'Average',
    value: 'Average'
  },
  {
    id: 4,
    name: 'Maximum',
    value: 'Maximum'
  }
];

export const TAG_COLORS_HISTORICAL_REQUESTS = {
  warning: { backgroundColor: '#ffba00', color: 'black', opacity: 0.75 },
  success: { backgroundColor: '#00a400', color: 'black', opacity: 0.75 },
  error: { backgroundColor: '#fa383e', color: 'black', opacity: 0.75 },
  info: { backgroundColor: '#54c7ec', color: 'black', opacity: 0.75 }
};

export function getLegendColor(value) {
  if (value >= 657 && value < 1597) {
    return '#90c6e4';
  } else if (value >= 1597 && value < 2600) {
    return '#f9d276';
  } else if (value >= 2600 && value < 3800) {
    return '#f38251';
  } else if (value >= 3800 && value < 5000) {
    return '#c10100';
  } else {
    return '#eaECF5'; // If the value doesn't fall into any range
  }
}

// ==============================|| THEME CONFIG  ||============================== //

const config = {
  /**
   * The props used for the theme font-style.
   * We provide static below options -
   * `'Inter', sans-serif`
   * `'Poppins', sans-serif`
   * `'Roboto', sans-serif`
   * `'Public Sans', sans-serif` (default)
   */
  fontFamily: `'Public Sans', sans-serif`,

  /**
   * The props used for display menu-items with multi-language.
   * We provide static below languages according to 'react-intl' options - https://www.npmjs.com/package/react-intl
   * 'en' (default)
   * 'fr'
   * 'ro'
   * 'zh'
   */
  i18n: 'en',

  /**
   * the props used for menu orientation (diffrent theme layout).
   * we provide static below options -
   * 'vertical' (default) - MenuOrientation.VERTICAL
   * 'horizontal' - MenuOrientation.HORIZONTAL
   */
  menuOrientation: MenuOrientation.VERTICAL,

  /**
   * the props used for show mini variant drawer
   * the mini variant is recommended for apps sections that need quick selection access alongside content.
   * default - false
   */
  miniDrawer: false,

  /**
   * the props used for theme container.
   * the container centers your content horizontally. It's the most basic layout element.
   * default - true which show container
   * false - will show fluid
   */
  container: true,

  /**
   * the props used for default theme palette mode
   * explore the default theme
   * below theme options -
   * 'light' (default) - ThemeMode.LIGHT
   * 'dark' - ThemeMode.DARK
   */
  mode: ThemeMode.LIGHT,

  /**
   * the props used for theme primary color variants
   * we provide static below options thoe s are already defaine in src/themes/theme -
   * 'default'
   * 'theme1'
   * 'theme2'
   * 'theme3'
   * 'theme4'
   * 'theme5'
   * 'theme6'
   * 'theme7'
   * 'theme8'
   */
  presetColor: 'revmaxai',

  /**
   * the props used for default theme direction
   * explore the default theme
   * below theme options -
   * 'ltr' (default) - ThemeDirection.LTR
   * 'rtl' - ThemeDirection.RTL
   */
  themeDirection: ThemeDirection.LTR
};

export default config;
